<template>
    <polygon :points="getSvgPolygon()" :fill="`url(#pattern-section${idSection}_${indexThisPolygon})`"
    :data-section="idSection"/>
</template>

<script>
    export default {
        name: "WPolygon",
        props: ['polygon', 'lengthPolygons', 'indexThisPolygon', 'indexThisSection', 'lengthSections', 'idSection'],
        methods: {
            getSvgPolygon() {
                let svgPolygon = '';
                this.polygon.forEach(i => {
                    svgPolygon = `${svgPolygon}${i.x},${i.y} `
                })
                return svgPolygon;
            },
            checkRendering() {
                // Проверяем, отрисовалась ли вся схема
                if ((this.indexThisPolygon === this.lengthPolygons - 1)&&(this.indexThisSection === this.lengthSections - 1)) {
                    this.$nextTick(function () {
                        // $nextTick - важно для проверки момента, когда отрисована вся схема
                        // Send the event on a channel (endRenderSeats)
                        this.$events.fire('endRenderSectionsList');
                    })
                }
            },
        },
        mounted() {
            this.checkRendering();
        }
    }
</script>

<style scoped>

</style>
